import React from "react";

const McqDisplayMcq = ({ nextQuestion, question }) => {
  return (
    <div className="  preview_question_box">

      <div className=" col-12 my-3 preview_selected_question">
        <div className=" pre_question_no">Q{nextQuestion + 1}</div>
        <div className=" pre_question">{question?.title}</div>
      </div>
      <div className=" col-11 mx-5  mandatory_box">
        {question?.is_mandatory && <span>*Mandatory question</span>}
      </div>
      {question?.options?.length > 0 &&
        question?.options?.map((option, index) => (
          <div key={index} className=" col-12 my-3 preview_selected_question">
            <div className="  pre_question_no">{option?.key}</div>
            <div className=" pre_question">{option?.value}</div>
          </div>
        ))}
    </div>
  );
};

export default McqDisplayMcq;
